import axiosFileDownloader from './axiosFileDownloader';
import axios from './axios';

export default class AttachmentService {

    getShipmentStatusLog(shipmentID) {
        return axios.get('api/shipment/status/log/list?shipmentID=' + shipmentID);
    }

  getShipmentPod(shipmentId) {
    return axios.get('api/shipment/pod?shipmentId=' + shipmentId, {
        responseType: 'blob'
    });
  }
}
